__turbopack_context__.v({
  "activeTabLine": "Tabs-module-scss-module__SoUFIa__activeTabLine",
  "tabActive": "Tabs-module-scss-module__SoUFIa__tabActive",
  "tabButtonLabel": "Tabs-module-scss-module__SoUFIa__tabButtonLabel",
  "tabContainer": "Tabs-module-scss-module__SoUFIa__tabContainer",
  "tabContent": "Tabs-module-scss-module__SoUFIa__tabContent",
  "tabList": "Tabs-module-scss-module__SoUFIa__tabList",
});
